export const AUTH_LOG_NAMES = {
    IDV_FAILED: 'idv_failed'
};
